import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BrandsCarousel = () => {
  const [brands, setBrands] = useState([]);
  const scrollerRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/products/brands`)
      .then(({ data }) => setBrands(data || []))
      .catch(() => setBrands([]));
  }, []);

  const scroll = (direction) => {
    const s = scrollerRef.current;
    if (!s) return;
    s.scrollBy({ left: direction * 320, behavior: "smooth" });
  };

  if (brands.length === 0) return null;

  return (
    <section
      data-testid="brands-carousel"
      className="py-24 md:py-28 border-t border-white/5 bg-[#080808]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="label-caps text-[color:var(--gold)] text-[10px] tracking-[0.3em] mb-4">
              Les maisons que nous distribuons
            </p>
            <h2 className="font-serif text-3xl md:text-5xl text-white leading-tight">
              Nos <em className="italic text-[color:var(--gold-soft)]">maisons</em>
            </h2>
          </div>
          <div className="hidden md:flex gap-2">
            <button
              onClick={() => scroll(-1)}
              data-testid="brands-scroll-left"
              aria-label="Précédent"
              className="w-11 h-11 border border-white/20 hover:border-[color:var(--gold)] flex items-center justify-center transition-colors"
            >
              <ChevronLeft size={16} strokeWidth={1.5} />
            </button>
            <button
              onClick={() => scroll(1)}
              data-testid="brands-scroll-right"
              aria-label="Suivant"
              className="w-11 h-11 border border-white/20 hover:border-[color:var(--gold)] flex items-center justify-center transition-colors"
            >
              <ChevronRight size={16} strokeWidth={1.5} />
            </button>
          </div>
        </div>

        <div
          ref={scrollerRef}
          className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-none"
          style={{ scrollbarWidth: "none" }}
        >
          {brands.map((b) => (
            <Link
              key={b.brand}
              to={`/recherche?q=${encodeURIComponent(b.brand)}`}
              data-testid={`brand-card-${b.brand.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative flex-shrink-0 w-[280px] md:w-[300px] snap-start bg-[#0F0F0F] border border-white/10 hover:border-[color:var(--gold)]/50 transition-colors overflow-hidden"
            >
              {b.sample_image && (
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={b.sample_image}
                    alt={b.brand}
                    className="w-full h-full object-cover opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                  />
                </div>
              )}
              <div className="p-6">
                <p className="font-serif text-2xl text-white group-hover:text-[color:var(--gold)] transition-colors">
                  {b.brand}
                </p>
                <p className="text-white/45 text-[10px] label-caps tracking-[0.25em] mt-2">
                  {b.in_stock_count} parfum{b.in_stock_count > 1 ? "s" : ""}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsCarousel;
